module.exports = __webpack_public_path__ + "img/login.a4af4ba9.jpg";